
export default function Loader() {
    return (
        <div className="loader">
            <span></span>
        </div>
    )
}